import styled from '@emotion/styled';
import { BREAKPOINTS_LEGACY } from '@sortlist-frontend/design-system/legacy';

export const StoriesCardsWrapper = styled.section`
  @media only screen and (min-width: ${BREAKPOINTS_LEGACY.xs}) {
    margin-top: -13.75rem;
  }
`;
